import { useState, useCallback } from 'react';

const useCheckVideo = () => {
	const [isVideo, setIsVideo] = useState(null);
	const [mediaType, setMediaType] = useState(null); // 'video', 'audio', or null

	const checkForVideo = useCallback((uri) => {
		const client = new XMLHttpRequest();

		client.open('GET', uri, true);
		client.send();
		client.onreadystatechange = function () {
			if (this.readyState === this.HEADERS_RECEIVED) {
				const contentType = client.getResponseHeader('Content-Type');

				if (contentType) {
					if (contentType.includes('video')) {
						setIsVideo(true);
						setMediaType('video');
					} else if (contentType.includes('audio')) {
						setIsVideo(true);
						setMediaType('audio');
					} else {
						setIsVideo(false);
						setMediaType(null);
					}
				} else {
					setIsVideo(false);
					setMediaType(null);
				}
			}
		};
	}, []);

	return {
		isVideo,
		mediaType, // 'video', 'audio', or null
		checkForVideo,
	}
}

export default useCheckVideo;